export type StoryKeyParams = {
  storyId: string;
  isTemplate: boolean;
};

export type StoryContentsKeyParams = {
  storyId: string;
  entityId: number;
  isTemplate: boolean;
};

export type ProposalsKeyParams = {
  storyId: string;
  entityId: number;
};

export const storyViewQueryKeys = {
  all: ['storyView'] as const,

  story: (params: StoryKeyParams) =>
    [...storyViewQueryKeys.all, 'story', params] as const,

  storyContents: (params: StoryContentsKeyParams) =>
    [...storyViewQueryKeys.all, 'storyContents', params] as const,

  proposals: (params: ProposalsKeyParams) =>
    [...storyViewQueryKeys.all, 'proposals', params] as const,
} as const;

export type StoryViewQueryKeys = typeof storyViewQueryKeys;
